import { Component, Input } from '@angular/core';

@Component({
    selector: 'lex-native-upload-batch-validation-meta',
    templateUrl: './native-upload-batch-validation-meta.component.html',
    styleUrls: ['./native-upload-batch-validation-meta.component.css'],
    standalone: false
})
export class NativeUploadBatchValidationMetaComponent {

  @Input() tableDataSource: any;
  @Input() uploadBatchTitle: string;
  @Input() uploadedTimestamp: string;

  public columnsToDisplay: string[] = ['myName', 'myValue'];
  private boldedProps: string[] = ['Unexpanded Document Count', 'Expanded Document Count', 'Ingested Document Count', 'Total Document Count', 'Page Count', 'Document Count'];
  private dateProp: string[] = ['Created'];
  
  public isBoldedProp(propertyName: string): boolean {
    return this.boldedProps.includes(propertyName);
  }

  public isDateProp(propertyName: string): boolean {
    return this.dateProp.includes(propertyName);
  }

  public isNumberProp(propertyName: string): boolean{
    return this.boldedProps.includes(propertyName);
  }
}
